import { makeObservable, observable } from 'mobx';
import { DataQueryResult } from '../DataQuery';

export class GridDataStore<TItem, TResultAdditionalInfo> {
  @observable
  data: DataQueryResult<TItem, TResultAdditionalInfo> = {
    items: [],
  };

  constructor() {
    makeObservable(this);
  }
}
